export default __webpack_public_path__ + "static/media/googleIcon.f68a62ed.svg";